import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appCaractereslimit]'
})
export class CaracteresLargoDirective {
  @Input('appMaxLength') maxLength: number; 
  @Input('appCaractereslimit') mensajeErrorId?: string; // ID del elemento para mostrar mensaje de error

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('input', ['$event']) onInput(event: any): void {
    const input = this.el.nativeElement;
    if (input.value.length > this.maxLength) {
      input.value = input.value.slice(0, this.maxLength); // Restringe al máximo permitido
    }

    // Mostrar o esconder el mensaje de error
    const mensajeErrorElement = this.mensajeErrorId
      ? document.getElementById(this.mensajeErrorId)
      : null;

    if (mensajeErrorElement) {
      if (input.value.length === this.maxLength) {
        this.renderer.setStyle(mensajeErrorElement, 'display', 'block');
      } else {
        this.renderer.setStyle(mensajeErrorElement, 'display', 'none');
      }
    }
  }
}
